module.exports = __webpack_public_path__ + "img/payment-successful.ad097877.svg";